export default {
  PIZZA_DROP: {
    id: "DROP_PIZZA",
    label: "st_drop_zone_aria_label"
  }
}
